import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'
import theme from 'dialogs/ComplaintConfirmation.scss'
import {getMessage as msg} from 'MessageBundle'
import {replaceJsxPlaceholders} from 'common/Replace'
import BaseComponent from 'common/BaseComponent.js'

export default class FormConfirmation extends BaseComponent {

    getUpdatingTime() {
        let updatingTime = moment(this.props.complaint.updated);
        return updatingTime.format('DD.MM.YYYY') + ' um ' + updatingTime.format('HH:mm') + ' Uhr';
    }

    renderHint = () => {
        if (this.props.authenticated) {
            return (
                <div>
                    {replaceJsxPlaceholders(msg('extendComplaintConfirmation.statusHint'),
                        <a href="javascript:void(0)" onClick={this.props.onStatusLinkClick}>{msg('extendComplaintConfirmation.statusLink')}</a>
                    )}
                    <p>{msg('extendComplaintConfirmation.hintMsgExtra')}</p>
                </div>
            );
        } else {
            return (
                <div>
                    <p>{msg('extendComplaintConfirmation.shortHint')}</p>
                </div>
            )
        }
    };

    render() {
        return (
            <div>
                <h2>{msg('extendComplaintConfirmation.header')}</h2>

                <div className={theme.msg + " " + theme.msgPositive + " " + theme.msgConfirm}>
                    {msg('extendComplaintConfirmation.successMsg')}
                </div>

                <div className={theme.details}>
                    <h3>{msg('extendComplaintConfirmation.details')}</h3>

                    <dl>
                        <dt htmlFor="complaintNumber">{msg('extendComplaintConfirmation.complaintNumber')} </dt>
                        <dd id="complaintNumber">{this.props.complaint.complaintNumber}</dd>

                        <dt htmlFor="updatingTime">{msg('extendComplaintConfirmation.updatingTime')} </dt>
                        <dd id="updatingTime">{this.getUpdatingTime()}</dd>

                        <dt htmlFor="externalReference" hidden={!this.props.complaint.externalReference}>{msg('extendComplaintConfirmation.externalReference')}</dt>
                        <dd id="externalReference" hidden={!this.props.complaint.externalReference}>{this.props.complaint.externalReference}</dd>
                    </dl>

                    {this.renderHint()}
                </div>

                <div className={theme.btnGroup}>
                    <button id="close-btn" onClick={this.closeWindow} className={theme.accent}>
                        {msg('extendComplaintConfirmation.closeWindowBtn')}
                    </button>
                </div>
            </div>
        )
    }
}
FormConfirmation.propTypes = {
    complaint: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    onStatusLinkClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/dialogs/ExtendComplaint/FormConfirmation.js